import React from "react";
import { useTranslation } from "react-i18next";
import CookieOutlinedIcon from "@mui/icons-material/CookieOutlined";

const CookiePolicy = () => {
  const { t } = useTranslation();

  return (
      <div className="flex flex-col mt-28 mb-8 py-6 px-4 sm:px-8 max-w-4xl mx-auto bg-white dark:bg-neutral-900/40 shadow-sm border border-gray-100 dark:border-white/5 rounded-2xl max-h-[85vh]">
        {/* Header Section */}
        <div className="flex flex-col items-center text-center gap-3 pt-4 pb-6 shrink-0">
          <div className="p-3 bg-blue-50 dark:bg-blue-500/10 rounded-xl text-blue-500 dark:text-dark-primary">
            <CookieOutlinedIcon className="w-7 h-7" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
            {t("cookies.title")}
          </h1>
          <div className="w-12 h-1 bg-blue-500 dark:bg-dark-primary rounded-full mt-1" />
        </div>

        {/* Content Area with Overflow Scroll */}
        <div className="flex-1 overflow-y-auto pr-2 space-y-6 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-200 dark:scrollbar-thumb-neutral-800 text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4">
          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("cookies.section1_title")}
            </h2>
            <p>{t("cookies.intro")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("cookies.section2_title")}
            </h2>
            <p>{t("cookies.what_are_cookies")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("cookies.section3_title")}
            </h2>
            <p>{t("cookies.how_we_use_cookies")}</p>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-3 uppercase tracking-wide">
              {t("cookies.section4_title")}
            </h2>
            <ul className="space-y-2 pl-1">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 mt-2 shrink-0" />
                <strong>{t("cookies.types_of_cookies.necessary")}</strong>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 mt-2 shrink-0" />
                <strong>{t("cookies.types_of_cookies.analytics")}</strong>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 mt-2 shrink-0" />
                <strong>{t("cookies.types_of_cookies.marketing")}</strong>
              </li>
            </ul>
          </section>

          <section className="p-5 bg-gray-50/50 dark:bg-neutral-800/20 border border-gray-100 dark:border-white/5 rounded-xl">
            <h2 className="text-base font-bold text-gray-900 dark:text-white mb-2 uppercase tracking-wide">
              {t("cookies.section5_title")}
            </h2>
            <p>{t("cookies.manage_cookies")}</p>
          </section>
        </div>
      </div>
  );
};

export default CookiePolicy;